import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=6996cf5c&scoped=true"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=6996cf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996cf5c",
  null
  
)

export default component.exports